import React from 'react';

type Props = {
	title: string;
	content: string;
	imgSrc: string;
	imgAlt: string;
};

export const StartConsultationCardMobile: React.FC<Props> = ({ title, content, imgSrc, imgAlt }) => {
	return (
		<div
			id="start-consultation-card-mobile"
			className="w-full relative rounded-[20px] justify-center bg-white min-h-[118px] overflow-hidden"
			style={{
				boxShadow: '8px 20px 80px 0px rgba(76, 152, 131, 0.19)',
				minHeight: '118px'
			}}
		>
		{/* Content */}
		<div className="flex flex-row justify-center items-stretch min-h-[118px]">
		<div id="start-consultation-card-photo" className="w-[50px] border-4 border-gray-200 overflow-hidden flex-shrink-0">
				<img src={imgSrc} alt={imgAlt} className="object-cover w-full h-full" />
			</div>

				<div id='mobile-step-description-and-title' className="flex-1 pl-2 pr-4 py-3 overflow-hidden">
				<div id="step-title" className="text-[18px] text-[#0D121A] font-poppins font-medium leading-[130%] mb-1" dangerouslySetInnerHTML={{ __html: title }} />
				<div id="step-text" className="text-[11px] text-[#0D2C54] font-medium font-poppins leading-[130%]" dangerouslySetInnerHTML={{ __html: content }} />
				</div>
			</div>
		</div>
	);
};

export default StartConsultationCardMobile;
